/* eslint-disable no-unused-vars */
import { createTheme, PaletteColorOptions } from '@mui/material/styles';
import shadows from '@mui/material/styles/shadows';

const [none, , , ...restShadows] = shadows;

const primary = '#284472';
const secondary = '#BFD7ED';
const base = '#EFEFEF';
const grey = '#989898';

declare module '@mui/material/styles/createPalette' {
  interface PaletteOptions {
    disabled?: PaletteColorOptions;
  }

  interface CommonColors {
    grey: string;
    translucentPrimary: string;
  }
}

const theme = createTheme({
  typography: {
    fontFamily: 'Inter, Arial',
    body1: {
      fontSize: '0.875rem',
      color: primary,
      lineHeight: 1.25,
    },
    body2: {
      lineHeight: 1.2,
      color: grey,
      fontSize: '0.75rem',
    },
    subtitle1: {
      lineHeight: 1.2,
    },
    subtitle2: {
      color: 'common.grey',
    },
  },
  spacing: (value: number) => `${value / 2}rem`,
  palette: {
    primary: {
      main: primary,
    },
    secondary: {
      main: secondary,
    },
    success: {
      main: '#73C45E',
    },
    info: {
      main: '#41729F',
    },
    error: {
      main: '#C65252',
    },
    disabled: {
      main: grey,
    },
    common: {
      grey,
      translucentPrimary: '#28447266',
    },
    background: { default: base },
  },
  shadows: [
    none,
    '0px 0.75rem 1.30rem rgba(0, 0, 0, 0.04)',
    '0px 1.0125rem 1.80rem rgba(0, 0, 0, 0.04)',
    ...restShadows,
  ],
  components: {
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontFamily: 'DM Sans',
          fontWeight: 'bold',
          textAlign: 'center',
        },
      },
      defaultProps: {
        color: 'primary',
      },
    },
    MuiDialogContentText: {
      defaultProps: {
        color: 'common.grey',
        fontSize: 'body1.fontSize',
        lineHeight: 1.35,
      },
      styleOverrides: {
        root: {
          fontFamily: 'DM Sans',
          fontStyle: 'italic',
          textAlign: 'center',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          textTransform: 'none',
          color: 'white',
          fontWeight: 'bold',
          borderRadius: '0.5rem',
        },
      },
      defaultProps: {
        variant: 'contained',
        disableElevation: true,
      },
    },
    MuiDialog: {
      defaultProps: {
        BackdropProps: {
          sx: {
            backdropFilter: 'blur(4px)',
          },
        },
      },
      styleOverrides: {
        paper: {
          borderRadius: '1.0625rem',
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          justifyContent: 'center',
        },
      },
    },
    MuiTextField: {
      variants: [
        {
          props: { variant: 'outlined', color: 'primary' },
          style: {
            border: '1px dashed disabled.main',
          },
        },
      ],
    },
  },
});

export default theme;
